import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const ANSWERS = 'answers'

/**
 * Form model
 */
const formModel = () => {
  return {
    [ANSWERS]: {
      label: `${t('common.checklist')}`,
      name: ANSWERS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [ANSWERS]: [],
}

export default formModel
